module.exports = __webpack_public_path__ + "img/what-is-lu.4eb3ba0c.png";